import { FC } from 'react';

import CorporateDashboard from '@/pages/CorporateDashboard';

const CorporateHomePage: FC = () => {
  return <CorporateDashboard />;
};

export default CorporateHomePage;
